// Lightweight one-shot celebration burst. Lazy-loads canvas-confetti so it never
// weighs on the initial bundle, and honours prefers-reduced-motion.
export async function celebrate(opts = {}) {
  try {
    const mod = await import("canvas-confetti");
    const confetti = mod.default || mod;
    const colors = ["#cfe86b", "#9bbb3a", "#E8C46A", "#ffffff"];
    const defaults = { origin: { y: 0.7 }, colors, disableForReducedMotion: true, zIndex: 9999 };
    confetti({ ...defaults, particleCount: 70, spread: 72, startVelocity: 46, ...opts });
    setTimeout(
      () => confetti({ ...defaults, particleCount: 45, spread: 110, startVelocity: 34, scalar: 0.9 }),
      180
    );
  } catch {
    // Confetti is a delight, never a dependency — silently no-op if it fails to load.
  }
}
